import { EARLY_ACCESS_TO_EXCLUSIVES } from "../constants";
export default state =>
  state.category.details?.loyaltyBenefit?.type === EARLY_ACCESS_TO_EXCLUSIVES;
